import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import ServiceActions, { ServiceTypes } from './serviceRedux'
import { MapTypes } from './mapRedux'

const SERVICE_CARD_CHANGED = ServiceTypes.SERVICE_CARD_CHANGED
const LOCATION_SELECTED_CHANGED = ServiceTypes.LOCATION_SELECTED_CHANGED
const MAX_BOUNDS_CENTER_ZOOM_CHANGED = MapTypes.MAX_BOUNDS_CENTER_ZOOM_CHANGED

const maxBoundsCenterZoomChanged = (maxBounds, center, zoom) => ({
  type: MAX_BOUNDS_CENTER_ZOOM_CHANGED,
  maxBounds,
  center,
  zoom
})


export const updateMapEpic = (action$, store) =>
  action$.ofType(SERVICE_CARD_CHANGED).mergeMap(({ service }) => {
    const { locationSelected } = store.getState().serviceCard
    const location = service.locations.find(loc => loc.name === locationSelected)
    const nextLocation = location || service.locations[0]
    const { maxBounds, longitude, latitude, zoom, name } = nextLocation
    const center = [longitude, latitude]
    return [
      maxBoundsCenterZoomChanged(maxBounds, center, zoom),
      ServiceActions.locationSelectedChanged(name)
           ]
  })



// WEBPACK FOOTER //
// ./src/redux/mapEpic.js